import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable()
export class AuthHttpInterceptor implements HttpInterceptor {
    constructor(public auth: AuthService) { }
    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const authToken = this.auth.getTokenType() + ' ' + this.auth.getAccessToken();

        req = req.clone({
            setHeaders: {
                Authorization: authToken
            }
        });

        return next.handle(req);
    }
}
